import { SlDialog } from '@shoelace-style/shoelace';
import { css, html, LitElement, nothing } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import { Artifact } from '../artifact.js';
import { linkStyles } from './cssstyles.js';

@customElement('image-attachment')
class ImageAttachment extends LitElement {
  @property({ attribute: false }) artifact?: Artifact;

  @query('sl-dialog') private _dialog?: SlDialog;

  override render() {
    const artifact = this.artifact;
    if (!artifact)
      return nothing;
    return html`
      <v-box class=wrapper>
        <img class="thumbnail dropshadow" src=${artifact.url} @click=${() => this._dialog?.show()}>
        <h-box class=caption>
          <span class=filename>${artifact.fileName}</span>
          <a class=download href=${artifact.url} download=${artifact.fileName}>
            <sl-icon name=download></sl-icon>
          </a>
        </h-box>
      </v-box>
      <sl-dialog label=${artifact.fileName}>
        <img class=full src=${artifact.url}>
      </sl-dialog>
    `;
  }

  static styles = [linkStyles, css`
    :host {
      display: block;
    }

    .wrapper {
      gap: var(--sl-spacing-x-small);
      align-items: center;
    }

    .thumbnail {
      width: var(--image-attachment-thumb-width, 200px);
      cursor: zoom-in;
      border-radius: var(--sl-border-radius-large);
    }

    .dropshadow {
      box-shadow: 0 0 4px 0px var(--sl-color-neutral-400);
    }

    .caption {
      gap: var(--sl-spacing-2x-small);
      align-items: center;
      font-size: var(--sl-font-size-small);
    }

    .filename {
      font-family: var(--sl-font-mono);
    }

    .download {
      display: inline-flex;
      align-items: center;
      color: var(--sl-color-neutral-600);
    }

    .download:hover {
      color: var(--sl-color-primary-600);
    }

    sl-dialog {
      --width: 90vw;
    }

    .full {
      display: block;
      max-width: 100%;
      max-height: 80vh;
      margin: 0 auto;
    }
  `];
}
